/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NbMenuService, NbDialogService, NbSidebarService } from '@nebular/theme';
import { Router } from '@angular/router';
import { MediathequeComponent } from './shared/mediatheque/mediatheque.component';
import { AuthService } from './auth/auth.service';
import { AutoLogoutService } from './auth/auto-logout/auto-logout.service';
@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
                private authService: AuthService, 
                private analytics: AnalyticsService,
                private menuService: NbMenuService, 
                private router:Router,
                private dialogService: NbDialogService, 
                private menu: NbMenuService,
                private sidebarService: NbSidebarService, 
                private autoLogoutService: AutoLogoutService /* on charge le service de deconnexion automatique pour qu'il s'instancifie */
              ) {
    
    
  
  }

  ngOnInit(): void {

  
    // this.analytics.trackPageViews();
    this.menu.onItemClick().subscribe((event) => {

      /* if (event.tag !== 'menu-sidebar')
      return; */

      /* if(event.item.title === "Médiathèque"){

        event.item.hidden
        this.dialogService.open(MediathequeComponent, {context: { mime: 'all'}});

      } */


      /* if(event.item.title === "category"){

        event.item.hidden;

      } */

      if( event.item.title === "Déconnexion" ){
        
          this.authService.logout();
          /* localStorage.clear();
          this.router.navigateByUrl('login'); */
          // window.location.reload();

      }
  

    });

    if (this.router.url === '/')
    this.router.navigateByUrl('key');

  }
 

  

  

}
